// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3O5C7","content":"LoadingAlert_content__13Daw"};